import * as Yup from 'yup';
import { EMAIL } from 'src/constants/regex.constants';

const signInValidationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(EMAIL, 'Please enter a valid email address')
    .required('Please enter your email'),
  password: Yup.string().required('Please enter the Password')
});

export default signInValidationSchema;
